__turbopack_context__.v({
  "wordpressStyle": "P1a8Rq_wordpressStyle",
  "wp-element-button": "P1a8Rq_wp-element-button",
});
